import * as React from 'react';
import {Svg, G, Path, Mask, Defs, ClipPath, Rect} from 'react-native-svg';

const MasterCard = props => {
  return (
    <Svg
      width={46}
      height={30}
      viewBox="0 0 46 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G clipPath="url(#clip0_24107_13140)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.758789 2.11422C0.758789 0.946571 1.70536 0 2.87301 0H43.748C44.9157 0 45.8622 0.94657 45.8622 2.11422V27.4849C45.8622 28.6526 44.9157 29.5991 43.748 29.5991H2.87302C1.70536 29.5991 0.758789 28.6526 0.758789 27.4849V2.11422Z"
          fill="#F4F6F7"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3772 22.5531C22.6586 22.5531 26.1293 19.0824 26.1293 14.801C26.1293 10.5196 22.6586 7.04883 18.3772 7.04883C14.0958 7.04883 10.625 10.5196 10.625 14.801C10.625 19.0824 14.0958 22.5531 18.3772 22.5531Z"
          fill="#D8232A"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3105 20.7812C24.6509 21.8881 26.3696 22.5531 28.2437 22.5531C32.5251 22.5531 35.9959 19.0824 35.9959 14.801C35.9959 10.5196 32.5251 7.04883 28.2437 7.04883C26.3696 7.04883 24.6509 7.71385 23.3105 8.82078C25.0322 10.2427 26.1295 12.3937 26.1295 14.801C26.1295 17.2083 25.0322 19.3593 23.3105 20.7812Z"
          fill="#ED9F2D"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3102 8.8208C21.5885 10.2427 20.4912 12.3937 20.4912 14.801C20.4912 17.2083 21.5885 19.3593 23.3102 20.7812C25.0319 19.3593 26.1291 17.2083 26.1291 14.801C26.1291 12.3937 25.0319 10.2427 23.3102 8.8208Z"
          fill="#D8232A"
        />
        <Mask
          id="mask0_24107_13140"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={20}
          y={8}
          width={7}
          height={13}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.3102 8.8208C21.5885 10.2427 20.4912 12.3937 20.4912 14.801C20.4912 17.2083 21.5885 19.3593 23.3102 20.7812C25.0319 19.3593 26.1291 17.2083 26.1291 14.801C26.1291 12.3937 25.0319 10.2427 23.3102 8.8208Z"
            fill="white"
          />
        </Mask>
        <G mask="url(#mask0_24107_13140)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.082 9.86719H27.5389V11.2767H19.082V9.86719ZM19.082 12.6855H27.5389V14.095H19.082V12.6855ZM27.5389 15.5059H19.082V16.9153H27.5389V15.5059ZM19.082 18.3242H27.5389V19.7337H19.082V18.3242ZM27.5389 21.1426H19.082V22.5521H27.5389V21.1426Z"
            fill="#ED9F2D"
          />
        </G>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.758789 1.5C0.758789 0.671573 1.43036 0 2.25879 0H31.2588C32.0872 0 32.7588 0.671573 32.7588 1.5V19.5C32.7588 20.3284 32.0872 21 31.2588 21H2.25879C1.43036 21 0.758789 20.3284 0.758789 19.5V1.5Z"
          fill="#E5E5E5"
          fillOpacity={0.01}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_24107_13140">
          <Rect
            width={45.1034}
            height={29.5991}
            fill="white"
            transform="translate(0.758789)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default MasterCard;
